import usePagination from '@/hooks/usePagination';
import { ContentFilters } from '@/types/schema';

import { useGroupContentsQuery } from '../graphql/queries/generated/groupContents';

function useGroupContents({
  filters,
  groupId,
  pause,
}: {
  filters: ContentFilters;
  groupId: string;
  pause: boolean;
}) {
  const { data, error, refetch, fetchMore, isFetching, isFetchingMore, isLoading, totalCount } =
    usePagination(
      useGroupContentsQuery,
      {
        filters,
        groupId,
      },
      {
        edgeKey: 'contents',
        pause,
      },
    );

  return {
    isLoading,
    isFetching,
    isFetchingMore,
    error,
    contents: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useGroupContents;
